// Central API configuration + authenticated fetch for the instructor dashboard.
// The base URL is configurable via VITE_API_BASE_URL so the same build works
// against localhost in dev and the real domain in production.

// Default to same-origin (empty base => relative "/api/..."), so the app works
// when served from a remote host/public IP: requests hit the same origin and are
// forwarded to the backend by the Vite dev proxy (dev) or nginx (prod).
// Set VITE_API_BASE_URL only if the API lives on a different origin.
export const API_BASE = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')

export const apiUrl = (path: string): string =>
  `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`

export const getToken = (): string | null => localStorage.getItem('admin_token')

export const clearAuth = (): void => {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_user')
}

/**
 * fetch wrapper that attaches the instructor JWT and, on a 401, clears the
 * stored session and bounces the user back to the login screen.
 */
export async function authFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = getToken()
  const headers = new Headers(init.headers || {})
  if (token) headers.set('Authorization', `Bearer ${token}`)

  const res = await fetch(apiUrl(path), { ...init, headers })

  if (res.status === 401) {
    clearAuth()
    if (!window.location.pathname.startsWith('/admin/login')) {
      window.location.href = '/admin/login'
    }
  }
  return res
}
